import { DomeRouter, React } from '@lexriver/dome'
import { Settings } from '../Settings'
import css from './App.m.scss'
import { LeftSidebar } from './components/LeftSidebar'
import { MainContent } from './components/MainContent'
import { RightSidebar } from './components/RightSidebar'
import { Topbar } from './components/Topbar'
import { convertStringToEnumProductSort, EnumProductSort } from './enums/EnumProductSort'
import { convertStringToEnumSortDirection, EnumSortDirection } from './enums/EnumSortDirection'
import { GlobalLeftSidebar } from './GlobalLeftSidebar'
import { GlobalState } from './GlobalState'
import { PopupCookies } from './popups/PopupCookies'
import { Seo } from './Seo'
import { ServerCustomPages } from './server-queries/ServerCustomPages'
import { ServerSettings } from './server-queries/ServerSettings'
import './static-styles/fontello.css'
import './static-styles/icomoon.css'
import './static-styles/myriad-pro.css'
import { SwipeEvent } from './SwipeEvent'
import { UrlGenerator } from './UrlGenerator'


const App = () => (
    <div id="app" class={css.app}>
        <Topbar />
        <LeftSidebar />
        <RightSidebar />
        <MainContent />
    </div>
)



const appDiv = <App />

document.body.appendChild(appDiv)

let swipeEventForApp = new SwipeEvent(appDiv)

swipeEventForApp.eventLeftToRight.subscribe(async () => {
    if (GlobalState.getCurrentUrl().startsWith('/m/gallery')) return
    if (!GlobalLeftSidebar.checkIfVisible()) {
        await GlobalLeftSidebar.showAsync()
    }
})

swipeEventForApp.eventRightToLeft.subscribe(async () => {
    if (GlobalLeftSidebar.checkIfVisible()) {
        await GlobalLeftSidebar.hideAsync()
    }
})

async function changePageAsync(url: string, pageContent: HTMLElement) {
    await GlobalState.eventPageChange.triggerAsync(url, pageContent)
}


async function subscribeToCustomPagesAsync() {

    const customPagesShortList = await ServerCustomPages.getShortListAsync()
    //console.log('customPagesShortList=', customPagesShortList)
    for (let item of customPagesShortList) {
        const url = Settings.addPrefixForUrl(item.url)
        DomeRouter.onRoute(url, true, async (params) => {
            const { PageCustom } = await import('./pages/PageCustom')
            await changePageAsync(url, <PageCustom url={item.url} id={Number(item.id)} />)
        })
    }
}

// setTimeout(() => {
//     GlobalState.eventPageChange.triggerAsync(<div>tho ho ho</div>)    
// }, 5000)


//changePage(<div>another page</div>)


function subscribeToInternalPages() {

    DomeRouter.onRoute(Settings.addPrefixForUrl('/gallery'), true, async (p, url) => {
        const { PageGalleryAlbums } = await import('./pages/PageGalleryAlbums')
        await changePageAsync(url, <PageGalleryAlbums />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/gallery/:albumId'), true, async (p, url) => {
        const { PageGalleryPhotos } = await import('./pages/PageGalleryPhotos')
        await changePageAsync(url, <PageGalleryPhotos albumId={parseInt(p.albumId)} />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/'),
        true,
        async (params, url) => {
            const { PageIndex } = await import('./pages/PageIndex')
            await changePageAsync(url, <PageIndex />)
        }
    )

    //     //DomeRouter.onRoute('/test', true, () => changePage(<PageTest />))
    //     DomeRouter.onRoute('/test', true, async () => {
    //         const { PageTest } = await import('./pages/PageTest')
    //         changePage(<PageTest />)
    //     })

    DomeRouter.onRoute(UrlGenerator.login, true, async (params, url) => {
        const { PageLogin } = await import('./pages/PageLogin')
        await changePageAsync(url, <PageLogin />)
    })

    DomeRouter.onRoute(UrlGenerator.resetPassword, true, async (params, url) => {
        const { PageResetPassword } = await import('./pages/PageResetPassword')
        await changePageAsync(url, <PageResetPassword />)
    })


    DomeRouter.onRoute(Settings.addPrefixForUrl('/reset-password/:confirmationCode'), true, async (p, url) => {
        const { PageConfirmResetPassword } = await import('./pages/PageConfirmResetPassword')
        await changePageAsync(url, <PageConfirmResetPassword confirmationCode={p.confirmationCode} />)
    })


    DomeRouter.onRoute(UrlGenerator.register, true, async (params, url) => {
        const { PageRegisterSelect } = await import('./pages/PageRegisterSelect')
        await changePageAsync(url, <PageRegisterSelect />)
    })

    DomeRouter.onRoute(UrlGenerator.registerWholeSale, true, async (params, url) => {
        const { PageRegisterWholesale } = await import('./pages/PageRegisterWholesale')
        await changePageAsync(url, <PageRegisterWholesale />)
    })

    DomeRouter.onRoute(UrlGenerator.registerRetail, true, async (params, url) => {
        const { PageRegisterRetail } = await import('./pages/PageRegisterRetail')
        await changePageAsync(url, <PageRegisterRetail />)
    })

    DomeRouter.onRoute(UrlGenerator.profile, true, async (params, url) => {
        const { PageProfile } = await import('./pages/PageProfile')
        await changePageAsync(url, <PageProfile />)
    })

    DomeRouter.onRoute(UrlGenerator.logout, true, async (params, url) => {
        const { PageLogout } = await import('./pages/PageLogout')
        await changePageAsync(url, <PageLogout />)
    })

    DomeRouter.onRoute(UrlGenerator.relogin, true, async (params, url) => {
        //console.log('on /relogin'); 
        const { PageLogout } = await import('./pages/PageLogout')
        await changePageAsync(url, <PageLogout nextUrl={UrlGenerator.login} />);
    })

    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/order-items/:orderId'),
        true,
        async (params, url) => {
            const { PageOrderItems } = await import('./pages/PageOrderItems')
            await changePageAsync(url, <PageOrderItems orderId={Number(params.orderId)} />)
        }
    )

    DomeRouter.onRoute(UrlGenerator.editUser, true, async (params, url) => {
        const { PageEditUser } = await import('./pages/PageEditUser')
        await changePageAsync(url, <PageEditUser />)
    })

    DomeRouter.onRoute(UrlGenerator.changePassword, true, async (params, url) => {
        const { PageChangePassword } = await import('./pages/PageChangePassword')
        await changePageAsync(url, <PageChangePassword />)
    })

    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/shop/:categoryId/:productType/:sortBy/:sortDirection/:pageNumber/:count'),
        true,
        async (params, url, scrollToPositionAsync) => {
            const { PageShop } = await import('./pages/PageShop')
            await changePageAsync(url, <PageShop
                productColor='a'
                categoryId={Number(params.categoryId)}
                productType={params.productType}
                sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.Article)}
                sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
                pageNumber={Number(params.pageNumber) || 1}
                count={Number(params.count) || Settings.countOfProductsPerPage}
                scrollToPositionAsync={scrollToPositionAsync}
            />)
        })

    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/shop/:categoryId/:productType/:productColor/:sortBy/:sortDirection/:pageNumber/:count'),
        true,
        async (params, url, scrollToPositionAsync) => {
            const { PageShop } = await import('./pages/PageShop')
            await changePageAsync(url, <PageShop
                productColor={params.productColor}
                categoryId={Number(params.categoryId)}
                productType={params.productType}
                sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.Article)}
                sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
                pageNumber={Number(params.pageNumber) || 1}
                count={Number(params.count) || Settings.countOfProductsPerPage}
                scrollToPositionAsync={scrollToPositionAsync}
            />)
        })


    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/after-payment/:orderId'),
        true,
        async (params, url) => {
            console.warn('after-payment!')
            const { PageAfterPayment } = await import('./pages/PageAfterPayment')
            await changePageAsync(url, <PageAfterPayment orderId={Number(params.orderId)} />)
        }
    )


    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/pay/:orderId'),
        true,
        async (params, url) => {
            const { PagePayForOrder } = await import('./pages/PagePayForOrder')
            await changePageAsync(url, <PagePayForOrder orderId={Number(params.orderId)} />)
        })


    // DomeRouter.onRoute(
    //     Settings.addPrefixForUrl('/shop/:categoryId/:productType/:sortBy/:sortDirection/:pageNumber/:count'),
    //     true,
    //     async (params, url) => {
    //         const { PageShop } = await import('./pages/PageShop')
    //         await changePageAsync(url, <PageShop
    //             categoryId={Number(params.categoryId)}
    //             productType={params.productType}
    //             sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.Article)}
    //             sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
    //             pageNumber={Number(params.pageNumber) || 1}
    //             count={Number(params.count) || Settings.countOfProductsPerPage}
    //             scrollToProductId={Number(params.scrollToProductId) || 0}
    //         />)
    //     })

    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/list/:listId'),
        true,
        async (params, url, scrollToPositionAsync) => {
            const { PageShop } = await import('./pages/PageShop')
            await changePageAsync(url, <PageShop
                productColor='a'
                listId={params.listId}
                productType={Settings.productTypeAll}
                pageNumber={1}
                count={Settings.countOfProductsPerPage}
                categoryId={0}
                scrollToPositionAsync={scrollToPositionAsync}
            />)
        }
    )

    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/list/:listId/:productType/:sortBy/:sortDirection/:pageNumber/:count'),
        true,
        async (params, url, scrollToPositionAsync) => {
            const { PageShop } = await import('./pages/PageShop')
            await changePageAsync(url, <PageShop
                productColor='a'
                listId={params.listId}
                productType={params.productType}
                sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.OrderId)}
                sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
                pageNumber={Number(params.pageNumber) || 1}
                count={Number(params.count) || Settings.countOfProductsPerPage}
                categoryId={0}
                scrollToPositionAsync={scrollToPositionAsync}
            />)
        })

    // DomeRouter.onRoute(
    //     Settings.addPrefixForUrl('/list/:listId/:productType/:sortBy/:sortDirection/:pageNumber/:count/:scrollToProductId'),
    //     true,
    //     async (params, url, scrollToPoitionAsync) => {
    //         const { PageShop } = await import('./pages/PageShop')
    //         await changePageAsync(url, <PageShop
    //             listId={params.listId}
    //             productType={params.productType}
    //             sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.OrderId)}
    //             sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
    //             pageNumber={Number(params.pageNumber) || 1}
    //             count={Number(params.count) || Settings.countOfProductsPerPage}
    //             categoryId={0}
    //             scrollToProductId={Number(params.scrollToProductId) || 0}
    //         />)
    //     })


    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/product-search/:query/:productType/:pageNumber/:count'),
        true,
        async (params, url, scrollToPositionAsync) => {
            const { PageShop } = await import('./pages/PageShop')
            await changePageAsync(url, <PageShop
                productColor='a'
                categoryId={0}
                searchQuery={params.query}
                productType={params.productType}
                sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.Article)}
                sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
                pageNumber={Number(params.pageNumber) || 1}
                count={Number(params.count) || Settings.countOfProductsPerPage}
                scrollToPositionAsync={scrollToPositionAsync}
            />)

        })

    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/product-search/:query/:productType/:productColor/:pageNumber/:count'),
        true,
        async (params, url, scrollToPositionAsync) => {
            const { PageShop } = await import('./pages/PageShop')
            await changePageAsync(url, <PageShop
                productColor={params.productColor}
                categoryId={0}
                searchQuery={params.query}
                productType={params.productType}
                sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.Article)}
                sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
                pageNumber={Number(params.pageNumber) || 1}
                count={Number(params.count) || Settings.countOfProductsPerPage}
                scrollToPositionAsync={scrollToPositionAsync}
            />)

        })

    // DomeRouter.onRoute(
    //     Settings.addPrefixForUrl('/product-search/:query/:productType/:pageNumber/:count/:scrollToProductId'),
    //     true,
    //     async (params, url) => {
    //         const { PageShop } = await import('./pages/PageShop')
    //         await changePageAsync(url, <PageShop
    //             categoryId={0}
    //             searchQuery={params.query}
    //             productType={params.productType}
    //             // sortBy={convertStringToEnumProductSort(params.sortBy, EnumProductSort.Article)}
    //             // sortDirection={convertStringToEnumSortDirection(params.sortDirection, EnumSortDirection.Asc)}
    //             pageNumber={Number(params.pageNumber) || 1}
    //             count={Number(params.count) || Settings.countOfProductsPerPage}
    //             scrollToProductId={Number(params.scrollToProductId) || 0}
    //         />)

    //     })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/product/:productIdOrUrl'), false, async (params, url) => {
        const { PageProduct } = await import('./pages/PageProduct')
        await changePageAsync(url, <PageProduct productIdOrUrl={params.productIdOrUrl} />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/favorites'), true, async (params, url) => {
        const { PageFavorites } = await import('./pages/PageFavorites')
        await changePageAsync(url, <PageFavorites />)
    })


    DomeRouter.onRoute(Settings.addPrefixForUrl('/basket'), true, async (params, url) => {
        const { PageBasket } = await import('./pages/PageBasket')
        await changePageAsync(url, <PageBasket scrollToProductId={0} />)
    })


    DomeRouter.onRoute(Settings.addPrefixForUrl('/basket/:scrollToProductId'), true, async (params, url) => {
        const { PageBasket } = await import('./pages/PageBasket')
        await changePageAsync(url, <PageBasket scrollToProductId={Number(params.scrollToProductId)} />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/order'), true, async (params, url) => {
        const { PageBasket } = await import('./pages/PageBasket')
        await changePageAsync(url, <PageBasket scrollToProductId={0} scrollToOrder={true} />)
    })


    DomeRouter.onRoute(Settings.addPrefixForUrl('/order/:scrollToProductId'), true, async (params, url) => {
        const { PageBasket } = await import('./pages/PageBasket')
        await changePageAsync(url, <PageBasket scrollToProductId={Number(params.scrollToProductId)} scrollToOrder={true} />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/custompage/:id'), true, async (params, url) => {
        const { PageCustom } = await import('./pages/PageCustom')
        await changePageAsync(url, <PageCustom id={Number(params.id)} />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl(UrlGenerator.blog), true, async (params,url) => {
        const { PageBlog } = await import('./pages/PageBlog')
        await changePageAsync(url, <PageBlog />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/blog/:url'), true, async (params,url) => {
        const { PageBlogPost } = await import('./pages/PageBlogPost')
        await changePageAsync(url, <PageBlogPost url={params.url} />)
    })


    DomeRouter.onRoute(
        Settings.addPrefixForUrl('/feedback/:type'),
        true,
        async (params, url) => {
            const { PageFeedback } = await import('./pages/PageFeedback')
            await changePageAsync(url, <PageFeedback type={params.type as any} />)
        }
    )

    DomeRouter.onRoute(UrlGenerator.club, true, async (params, url) => {
        const { PageClub } = await import('./pages/PageClub')
        await changePageAsync(url, <PageClub />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl('/buy-promocodes'), true, async() => {
        DomeRouter.navigate(Settings.addPrefixForUrl(UrlGenerator.buyCoupons))
        // const {PageBuyCoupons} = await import('./pages/PageBuyCoupons')
        // await changePageAsync(<PageBuyCoupons />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl(UrlGenerator.buyCoupons), true, async (params, url) => {
        const { PageBuyCoupons } = await import('./pages/PageBuyCoupons')
        await changePageAsync(url, <PageBuyCoupons />)
    })

    DomeRouter.onRoute(Settings.addPrefixForUrl(UrlGenerator.buyCouponsInfo), true, async (params, url) => {
        const { PageBuyCouponsInfo } = await import('./pages/PageBuyCouponsInfo')
        await changePageAsync(url, <PageBuyCouponsInfo />)
    })


    DomeRouter.onRoute(
        UrlGenerator.pageNewOrderSuccessful,
        true,
        async (params, url) => {
            const { PageNewOrderSuccessful } = await import('./pages/PageNewOrderSuccessful')
            await changePageAsync(url, <PageNewOrderSuccessful />)
        }
    )

}


function subscribeToNotFoundPage() {
    DomeRouter.onNotFound(async () => {
        //console.log('$$$$$ on route not found! $$$$$')
        // const {PageIndex} = await import('./pages/PageIndex')
        // await changePageAsync('', <PageNotFound />)
        // await changePageAsync('', <PageIndex />)
        DomeRouter.navigate(UrlGenerator.home)
    })
}



async function startAsync() {
    void loadDefaultSeoAsync() // no await here!
    subscribeToInternalPages()

    try {
        await subscribeToCustomPagesAsync()
    } catch (x) {
        console.error('unable to subscribeToCustomPages', x)
    }
    subscribeToNotFoundPage() //TODO: uncomment this!
    DomeRouter.resolveUrl()
    await PopupCookies.showPopupAsync()

}

async function loadDefaultSeoAsync() {
    document.title = await ServerSettings.getOnlyValueAsync('seo-title')
    Seo.setKeywords(await ServerSettings.getOnlyValueAsync('seo-keywords'))
    Seo.setDescription(await ServerSettings.getOnlyValueAsync('seo-description'))
}

void startAsync()


// window.addEventListener('scroll', () => {
//     //console.log('scroll', window.pageYOffset)
//     //DomeEventDispatcher.triggerEvent(EnumDomeEventDispatcherEvents.WindowScroll)
//     GlobalState.onScrollEvent.triggerAsync()
// })

// window.addEventListener('contextmenu', (e) => {
//     //if(e.target?.tagName == 'img'){
//     if (e.target instanceof HTMLImageElement) {
//         e.preventDefault()
//     }
// })